<template>
  <div class="py-1 px-2 text-center border-r border-gray-200 dark:border-gray-700">
    <div class="flex flex-col items-center">
      <div class="inline-block text-center bg-blue-100/50 dark:bg-blue-900/50 border border-blue-200 dark:border-blue-700 rounded py-0 px-1 text-xs font-medium">
        {{ hours }}h
      </div>

      <div v-if="mechanicsCount" class="text-xs text-gray-500 mt-1">
        {{ mechanicsCount }} {{ mechanicsCount === 1 ? 'mech' : 'mechs' }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  hours: number;
  mechanicsCount?: number;
}>();
</script>
